/*
创建者 李志远
补充我的资料
*/
联盟商家
<template>
  <div class="crew_right">
    <div class="conInner">
      <div class="data">
        <h2>商品图管理</h2>
      </div>
      <div class="lm-con">
        <div class="inner">
          <div class="content">
            <div>
              <div class='msgbox'>
                <p>最多上传10张</p>
                <div class='img_box'>
                  <div
                    class="demo-upload-list"
                    v-for="(item,index) in goodsImg"
                    :key="index"
                  >
                    <img :src="item" />
                    <div class="demo-upload-list-cover">
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(item)"
                      ></Icon>
                      <Icon
                        type="ios-trash-outline"
                        @click.native="handleRemoveList(index)"
                      ></Icon>
                    </div>
                  </div>
                  <Upload
                    v-if="goodsImg.length < 10"
                    :show-upload-list="false"
                    :on-exceeded-size="handleMaxSize"
                    :on-success="handleSuccessListGood"
                    :on-format-error="handleFormatError"
                    :before-upload="handleBeforeUpload"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers='{"Auth-Token": upHeaders}'
                    multiple
                    type="drag"
                    :action="UploadUrl()"
                    style="display: inline-block;width:150px"
                  >
                    <div style="width: 150px;height:150px;line-height: 150px;">
                      <Icon
                        type="ios-camera"
                        size="40"
                      ></Icon>
                    </div>
                  </Upload>
                </div>
              </div>
              <div class='regis_box'>
                <input
                  class="regis_ent"
                  type="button"
                  value="立即保存"
                  id="discussBtn"
                  v-on:click="handleSubmit(1)"
                >
              </div>
            </div>
            <Modal
              title="图片预览"
              v-model="visible"
            >
              <img
                :src="showImageUrl"
                v-if="visible"
                style="width: 100%"
              />
            </Modal>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { getSession, getNowFormatDate } from "utils/tool";
import { isApplyLeague, findMemberLeague, modifyMemberLeague } from "api/user";
import { encryptDes } from "utils/des";

export default {
  data() {
    return {
      status: "", //1联盟商家资料;2商品图片
      apply: "", //审核状态 0待审核 1审核通过 2审核不通过 状态0不能修改记录
      sn: "", //联盟商家标识，编号
      leagueName: "", //联盟商家店铺名称
      attr: "", //地址
      tel: "", //电话
      leagueId: "", //联盟商家id
      notPassReason: "", //拒绝理由
      idImg: [], //身份证图片
      licenseImg: [], //营业执照图片
      storeBannerImg: [], //店面横幅图片
      shopImg: [], //店铺照片
      goodsImg: [], //商品图图片
      applyStatus: "", //是否可编辑0：通过不通过 1：审核中

      MEMBER_HOST: process.env.PROTOCOL + "://" + process.env.MEMBER_HOST,
      showImageUrl: "", //预览图片地址
      visible: false, //预览图片是否显示
      upHeaders: "", //图片上传请求头
      legionName: "", // 所属市场
    };
  },
  watch: {
    $route(to, from) {
      if (to.query.status != from.query.status) {
        this.status = to.query.status;
        this.init(); //重新加载数据
      }
    },
  },
  created() {
    this.init();
    this.isApplyLeague();
    this.getUpHeaders();
  },
  methods: {
    init() {
      if (!this.$route.query.status) {
        this.status = 1;
      } else {
        this.status = Number(this.$route.query.status);
      }
    },
    //图片上传接口
    UploadUrl: function () {
      let actionPath = this.MEMBER_HOST + "/api/common/upload";
      return actionPath;
    },
    //设置图片上传请求头
    getUpHeaders() {
      let commonBody = {
        client: "PC",
        transeq: getNowFormatDate(),
        mac: "",
        product: "GDOMALL", // 产品类型（必传参数）
        accessSource: "PC", // 访问来源（必传参数）
        version: "1.0.0", //当前请求来源的版本号（必传参数）
        sid: getSession("sid"), // 结算返回的uid（登录状态必传参数）
      };
      this.upHeaders = encryptDes(JSON.stringify(commonBody));
    },
    //查询是否申请过联盟商家
    isApplyLeague() {
      isApplyLeague({}).then((res) => {
        if (res.data) {
          if (res.resCode == 1) {
            this.sn = res.data.sn;
            this.applyStatus = res.data.status;
            if (this.applyStatus == 2) {
              this.findMemberLeague();
            } else {
              return;
            }
          }
        }
      });
    },
    //查询联盟商家信息
    findMemberLeague() {
      findMemberLeague({}).then((res) => {
        if (res.resCode == 1) {
          let data = res.data;
          this.leagueId = data.leagueId;
          if (data.goodsImg) {
            this.goodsImg = this.toArr(data.goodsImg);
          }
        } else {
          layer.msg(res.resDesc, { icon: 2 });
          return;
        }
      });
    },

    // 校验图片数量
    handleBeforeUpload(file) {
      const check = this.goodsImg.length < 11;
      if (!check) {
        this.$Message.warning("上传文件数量达到上限");
      }
      return check;
    },
    //上传成功
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片大小限制",
        desc: "文件 " + file.name + "太大,不能超过 2M.",
      });
    },

    handleView(imageUrl) {
      this.showImageUrl = imageUrl;
      this.visible = true;
    },
    handleRemoveList(index) {
      // 删除商品
      let self = this;
      layer.confirm(
        "是否确定删除?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          layer.msg("删除成功", { icon: 1 });
          self.goodsImg.splice(index, 1);
        },
        function () {}
      );
    },

    //上传失败
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "请选择jpg、png或者jpeg.",
      });
    },

    //商品上传成功
    handleSuccessListGood(res, file) {
      this.$Message.success(res.resDesc);
      if (res.resCode == 1) {
        var localImage = res.data.fileDetailUrl;
        this.goodsImg.push(localImage);
      }
    },
    //保存提交
    handleSubmit() {
      var _params = {
        goodsImg: this.goodsImg.join(","),
        leagueId: this.leagueId,
      };
      var self = this;
      var lock = false;
      layer.confirm(
        "是否确定保存?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          if (!lock) {
            lock = true; //锁定
            modifyMemberLeague(_params).then((res) => {
              if (res.resCode === 1) {
                layer.msg(res.resDesc, { icon: 1 });
                self.findMemberLeague();
              } else {
                layer.msg(res.resDesc, { icon: 2 });
                return;
              }
            });
          }
        },
        function () {}
      );
    },
    //将图片字符串转数组
    toArr(str) {
      if (str) {
        var _str = str.split(",");
        return _str;
      }
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.lm-con {
  width: 100%;
  min-height: 500px;
  background: #ffffff;
  border-top: #dfdfdf 1px solid;
  .inner {
    width: 960px;
    margin: 0 auto;
    padding-bottom: 36px;
    .msg {
      width: 100%;
      height: 30px;
      line-height: 30px;
      margin-top: 20px;
      font-weight: bold;
      font-size: 16px;
      color: #666;
    }
    h2 {
      padding: 30px 0 20px;
      font-size: 24px;
      font-weight: 400;
      text-align: center;
    }
    .content {
      width: 60%;
      font-size: 14px;
      padding: 0 20px;
      .msgbox {
        padding: 10px 0;
        p {
          color: #222;
          em {
            color: #9e9e9e;
          }
        }
        .img_box {
          margin: 10px;
        }
        .id_box {
          div {
            .no-img {
              width: 100px;
              height: 70px;
              margin: 25px auto;
            }
            img {
              width: 100%;
              height: auto;
            }
            span {
              display: block;
              width: 100%;
              height: 30px;
              line-height: 30px;
              background: #10aeff;
              color: #fff;
              font-size: 14px;
              text-align: center;
              position: absolute;
              bottom: 0;
            }
            span:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
    p {
      padding: 5px 0;
      font-weight: 400;
    }
  }
}
.border_b {
  border-bottom: 1px solid #dddddd;
}
.camera_box {
  width: 100px;
  height: 80px;
  line-height: 80px;
}
.demo-upload-list {
  display: inline-block;
  width: 150px;
  height: 150px;
  text-align: center;
  line-height: 150px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 15px;
  img {
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.regis_box {
  width: 100%;
  text-align: center;
  margin-top: 50px;
  .regis_ent {
    padding: 0px;
    margin: 0px;
    height: 30px;
    line-height: 30px;
    width: 100px;
    border: medium none;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    font-family: 微软雅黑, 宋体;
    background-color: #d93600;
    color: #fff;
    outline: medium none;
    display: inline-block;
    font-size: 14px;
    border-radius: 4px;
    -moz-user-select: none;
  }

  .regis_ent:hover {
    text-decoration: none !important;
    background-color: #ff4400;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// uploadShopImg.vue?b8a06e0a